import { render, staticRenderFns } from "./DetailTab.vue?vue&type=template&id=6cce3bd0&scoped=true"
import script from "./DetailTab.vue?vue&type=script&lang=ts"
export * from "./DetailTab.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./DetailTab.vue?vue&type=style&index=0&id=6cce3bd0&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6cce3bd0",
  "e22d40ec"
  
)

export default component.exports